import React from 'react';
import axios from 'axios';
import moment from 'moment';
import qs from 'qs';
import { withCookies } from 'react-cookie';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { DatePicker } from '@material-ui/pickers';
import { ReCaptcha } from 'react-recaptcha-v3';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import PasswordInput from '../parts/PasswordInput';
import store from '../../store/index';
import { setData } from '../../actions/index';
import {
  saveUserToStore,
  setSessionCredentials,
  googleRecaptcha,
} from '../../helpers';

const styles = () => ({
  button: {
    marginTop: 40,
    padding: '16px 32px',
    backgroundColor: '#f56a12',
    '&:hover': {
      backgroundColor: '#C24C03',
    },
  },
  loginWithDelimiter: {
    margin: '30px 0',
    textAlign: 'center',
  },
  loginWithDelimiterLine: {
    height: 1,
    background: '#333333',
    marginBottom: -11,
  },
  loginWithDelimiterText: {
    color: '#333333',
    display: 'inline-block',
    background: '#f2f6f8',
    padding: '2px 20px',
  },
  buttonGoogle: {
    display: 'block',
    margin: '0 auto',
    padding: '8px 16px',
    backgroundColor: '#ffffff',
    color: '#333333',
    '&:hover': {
      backgroundColor: '#eeeeee',
    },
  },
  buttonGoogleImage: {
    background: 'url(/img/vector/google-logo.svg) no-repeat',
    backgroundSize: 'contain',
    width: 60,
    height: 21,
    display: 'block',
    margin: '0 auto',
  },
  textField: {
    margin: '8px 0',
  },
});

class StudentLoginPage extends React.Component {
  constructor(props) {
    super(props);

    let minDate = new Date();
    minDate.setFullYear(1995);

    this.state = {
      code: '',
      isDobDialogOpen: false,
      dob: null,
      remember: true,
      minDate: minDate,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onInputKeyDown = this.onInputKeyDown.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.onLoginClick = this.onLoginClick.bind(this);
    this.onLoginGoogleClick = this.onLoginGoogleClick.bind(this);
    this.onDobDialogClose = this.onDobDialogClose.bind(this);
    this.onDobDialogButtonClick = this.onDobDialogButtonClick.bind(this);
    this.onMobileLogin = this.onMobileLogin.bind(this);

    document.addEventListener('mobile-login', this.onMobileLogin);
  }

  onInputKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.onLoginClick(event);
    }
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value.toUpperCase(),
    });
  }

  onCheckboxChange(event) {
    this.setState({
      [event.target.name]: !this.state[event.target.name],
    });
  }

  handleLoginResponse(response, remember_me) {
    const {
      cookies,
      enqueueSnackbar,
    } = this.props;

    if (response.data.success) {
      saveUserToStore(response.data.data);
      if (response.data.meta?.session_id) {
        setSessionCredentials(cookies, response.data.meta.session_id, remember_me);
      }

      const selectedPupilData = response.data.data;
      if (window.location.hash) {
        const hashSplit = window.location.hash.split(',');
        selectedPupilData.defaultView = hashSplit[1];

        if (typeof hashSplit[2] !== 'undefined') {
          store.dispatch(setData(hashSplit[2], 'openModal'));
        }
      }

      store.dispatch(setData(selectedPupilData, 'selectedPupil'));
    } else {
      enqueueSnackbar(response.data.error, {
        variant: 'error',
        autoHideDuration: 10000,
      });
    }
  }

  onLoginClick() {
    axios
      .post(`${window.apiUrl}/hasdob`, qs.stringify({
        code: this.state.code,
      }))
      .then((response) => {
        if (response.data.data.has_dob) {
          this.setState({
            isDobDialogOpen: true,
          });
        } else {
          googleRecaptcha('student_login', (token) => {
          axios
            .post(`${window.apiUrl}/login`, qs.stringify({
              code: this.state.code,
              remember: this.state.remember,
              'recaptcha-token': token,
            }))
            .then((loginResponse) => {
              this.handleLoginResponse(loginResponse, this.state.remember);
            });
          });
        }
      })
      .catch((thrown) => {});
  }

  onLoginGoogleClick() {
    window.location.href = '/student/glogin';
  }

  onDobDialogClose() {
    this.setState({
      isDobDialogOpen: false,
    });
  }

  onDobDialogButtonClick() {
    googleRecaptcha('student_login', (token) => {
    axios
      .post(`${window.apiUrl}/login`, qs.stringify({
        code: this.state.code,
        remember: this.state.remember,
        dob: this.state.dob
          ? this.state.dob.format('YYYY-MM-DD')
          : '',
        'recaptcha-token': token,
      }))
      .then((response) => {
        this.handleLoginResponse(response, this.state.remember);
      })
      .catch((thrown) => {});
    });
  }

  onMobileLogin(e) {
    const {
      enqueueSnackbar,
    } = this.props;

    if (e.detail.action === 'google_login') {
      if (e.detail.error) {
        enqueueSnackbar('There was an error: ' + JSON.stringify(e.detail.error), {
          variant: 'error',
          autoHideDuration: 5000,
        });
      } else {
        window.location.href ='/student/glogin?mobile_token=' + e.detail.data.tokens.accessToken;
      }
    }
  }

  render() {
    const {
      code,
      isDobDialogOpen,
      dob,
    } = this.state;
    const {
      classes,
      t,
    } = this.props;

    return (
      <div className="student-login-page">
        <PasswordInput
          label={t('Access code')}
          placeholder={t('Your access code')}
          fullWidth
          margin="normal"
          name="code"
          InputLabelProps={{
            shrink: true,
          }}
          value={code}
          onChange={this.onInputChange}
          onKeyDown={this.onInputKeyDown}
          className={classes.textField}
          autoComplete="off"
          required
        />
        <Typography>
          {t('Please enter the access code supplied by your teacher.')}
        </Typography>
        <FormControlLabel
          control={(
            <Checkbox
              checked={this.state.remember}
              onChange={this.onCheckboxChange}
              value="true"
              name="remember"
            />
          )}
          margin="normal"
          label={t('Remember me')}
        />
        <ReCaptcha
          sitekey={googleRecaptchaSiteKey}
          action="student_login"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={this.onLoginClick}
          className={`login-button ${classes.button}`}
        >
          {t('Log In')}
        </Button>
        {!!allowGoogleSso && (
          <>
            <div className={classes.loginWithDelimiter}>
              <div className={classes.loginWithDelimiterLine}></div>
              <div className={classes.loginWithDelimiterText}>
                {t('Log in with')}
              </div>
            </div>
            <Button
              variant="contained"
              color="primary"
              onClick={this.onLoginGoogleClick}
              className={`google-sso-button ${classes.buttonGoogle}`}
            >
              <span className={classes.buttonGoogleImage}></span>
            </Button>
          </>
        )}
        {/* TODO: replace with the existing DOB dialog */}
        <Dialog
          open={isDobDialogOpen}
          onClose={this.onDobDialogClose}
          aria-labelledby="dob-form-dialog-title"
          className="dob-dialog"
        >
          <DialogTitle id="dob-form-dialog-title">
            {t('Date of birth')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t('Please enter your date of birth below.')}
            </DialogContentText>
            <div style={{ textAlign: 'center' }}>
              <DatePicker
                variant="inline"
                openTo="year"
                views={['year', 'month', 'date']}
                label={t('Date of Birth')}
                value={dob}

                initialFocusedDate={moment().subtract(14, 'years')}
                onChange={dob => this.setState({ dob })}
                format={dateFormat}
                autoComplete="off"
                disableFuture
                autoOk
                PopoverProps={{
                  anchorOrigin: { horizontal: 'center', vertical: 'center' },
                  transformOrigin: { horizontal: 'center', vertical: 'center' },
                }}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.onDobDialogButtonClick}
              color="primary"
              className="dob-dialog-confirm-button"
            >
              {t('Ok')}
            </Button>
            <Button
              onClick={this.onDobDialogClose}
              className="dob-dialog-cancel-button"
            >
              {t('Cancel')}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(withCookies(withSnackbar(withTranslation()(StudentLoginPage))));
